import { useTranslation } from '@/shared/lib/common/i18n';
import { CANARY } from '@/shared/lib/constants/rolloutGroup';
import { useRolloutGroupSync } from '@/shared/lib/hooks/useRolloutGroupSync';
import { ConfirmDialog } from '@/shared/ui/DialogKit';

const RolloutGroupPrompt = () => {
  const { t } = useTranslation();
  const { showPrompt, targetGroup, reload, dismiss } = useRolloutGroupSync();

  if (!showPrompt) return null;

  const movingToCanary = targetGroup === CANARY;
  const title = movingToCanary ? t.common.rolloutGroup.joinTitle : t.common.rolloutGroup.leaveTitle;
  const message = movingToCanary ? t.common.rolloutGroup.joinMessage : t.common.rolloutGroup.leaveMessage;

  return (
    <ConfirmDialog
      open
      title={title}
      message={message}
      onAgree={reload}
      onDisagree={dismiss}
      hideDialog={dismiss}
      agreeLabel={t.common.rolloutGroup.reloadNow}
      disagreeLabel={t.common.rolloutGroup.notNow}
    />
  );
};

export default RolloutGroupPrompt;
